export const resources = {
  MediaUpdateVideoFailed: '',
  MediaUpdateVideoSuccess: '',
  MediaReviewRequestSucceeded: '',
  MediaReviewRequestFailed: ''
};
